import {
    createContext
} from "react";
import type {
    BubbleContentToggleContextType
} from "./type";

export const BubbleContentToggleContext = createContext<BubbleContentToggleContextType>({
    isOpen: false
});
